import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.li(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: [
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.xxl}`,
      `${defaultTheme.spacing.xl} ${defaultTheme.spacing.xxl}`,
    ],
    position: 'relative',
    height: '58px',
  }),
);

export const Content = styled.div(() =>
  mq({
    alignItems: 'center',
    verticalAlign: 'middle',
    justifyContent: 'space-between',
  }),
);

export const RaceInfo = styled
  .a(() =>
    mq({
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    }),
  )
  .withComponent(Link);

export const LeftBox = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '30%',
    justifyContent: 'center',
  }),
);

export const CenterBox = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '35%',
    justifyContent: 'center',
  }),
);

export const RightBox = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    width: '35%',
    justifyContent: 'center',
  }),
);

export const VelodromeName = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'normal',
    fontSize: defaultTheme.font.size.m,
  }),
);

export const IconArea = styled.span(() =>
  mq({
    alignItems: 'center',
    verticalAlign: 'text-top',
    paddingLeft: defaultTheme.spacing.xs,
  }),
);

export const RacerName = styled.div(() =>
  mq({
    display: 'block',
    fontSize: [
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.l,
    ],
  }),
);

export const RacerData = styled.div(() =>
  mq({
    display: 'block',
    fontWeight: 'normal',
    fontSize: defaultTheme.font.size.s,
  }),
);

export const Times = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'normal',
    lineHeight: '16px',
    margin: '2px',
  }),
);

export const DeadLine = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    paddingLeft: '8px',
    color: defaultTheme.color.primary,
    '& time': {
      marginLeft: defaultTheme.spacing.xs,
    },
  }),
);
